import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translationEN.json';
import translationukUA from './locales/ukUA/translationukUA.json';
import translationCZ from './locales/cz/translationCZ.json';

const defaultLanguage = 'en';

const resources = {
  en: {
    translation: translationEN,
  },
  ukr: {
    translation: translationukUA,
  },
  cz: {
    translation: translationCZ,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: !defaultLanguage ? 'en' : defaultLanguage,
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
